import React from 'react';
import VerseHighlighter from '../VerseHighlighter';

const InteractiveVerse = ({ verse, highlights, memo, onVerseClick, onHighlightClick, onNoteClick, isMenuActive, highlightColor, children, verseText, ...props }) => (
  <VerseHighlighter
    {...props}
    verseText={verseText || verse.text}
    verseId={verse.verse_id}
    book={verse.book}
    chapter={verse.chapter}
    version={verse.version}
    verseNumber={verse.verse}
    highlights={highlights}
    hasNote={memo}
    handleVerseClick={onVerseClick}
    onHighlightClick={onHighlightClick}
    onNoteClick={onNoteClick}
    isMenuActive={isMenuActive}
    highlightColor={highlightColor}
  >
    {children}
  </VerseHighlighter>
);

export default InteractiveVerse;
